(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  class BeforeAfterComparison {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('.before-after-comparison__viewport');
      this.afterLayer = root.querySelector('[data-after-layer]');
      this.divider = root.querySelector('[data-divider]');
      this.handle = root.querySelector('[data-handle]');
      this.isDragging = false;
      this.position = Number(root.dataset.initial || 50);

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);

      this.setPosition(this.position, false);
      this.bindEvents();
    }

    bindEvents() {
      this.handle.addEventListener('pointerdown', this.onPointerDown);
      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      this.handle.addEventListener('keydown', this.onKeyDown);
    }

    onPointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (event.target.closest('[data-handle]') === null && event.currentTarget === this.viewport) {
        this.updateFromClientX(event.clientX);
      }

      this.isDragging = true;
      this.root.classList.add('is-dragging');
      const captureTarget = event.currentTarget === this.handle ? this.handle : this.viewport;
      captureTarget.setPointerCapture?.(event.pointerId);
      this.updateFromClientX(event.clientX);
      window.addEventListener('pointermove', this.onPointerMove);
      window.addEventListener('pointerup', this.onPointerUp);
      window.addEventListener('pointercancel', this.onPointerUp);
      event.preventDefault();
    }

    onPointerMove(event) {
      if (!this.isDragging) return;
      this.updateFromClientX(event.clientX);
    }

    onPointerUp() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.root.classList.remove('is-dragging');
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
      window.removeEventListener('pointercancel', this.onPointerUp);
    }

    onKeyDown(event) {
      const step = event.shiftKey ? 10 : 2;
      let next = this.position;

      if (event.key === 'ArrowLeft') next -= step;
      if (event.key === 'ArrowRight') next += step;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = 100;
      if (next === this.position) return;

      event.preventDefault();
      this.setPosition(next, true);
    }

    updateFromClientX(clientX) {
      const rect = this.viewport.getBoundingClientRect();
      const next = ((clientX - rect.left) / rect.width) * 100;
      this.setPosition(next, true);
    }

    setPosition(value, updateAria) {
      const clamped = Math.max(0, Math.min(100, value));
      this.position = clamped;
      const positionValue = `${clamped}%`;

      this.root.style.setProperty('--ba-position', positionValue);
      this.afterLayer.style.clipPath = `inset(0 0 0 ${positionValue})`;
      this.divider.style.left = positionValue;

      if (updateAria) {
        this.handle.setAttribute('aria-valuenow', String(Math.round(clamped)));
      }
    }
  }

  const initBeforeAfterSections = () => {
    document.querySelectorAll('[data-before-after]').forEach((element) => {
      if (element.dataset.initialized === 'true') return;
      element.dataset.initialized = 'true';
      new BeforeAfterComparison(element);
    });
  };

  initBeforeAfterSections();
  document.addEventListener('shopify:section:load', initBeforeAfterSections);

  } catch(e) { console.error(e); }
})();
})();
